import PayUserVariable from '@/api/hr/pay-user-variable'
import PaySystemVariable from '@/api/hr/pay-system-variable'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  systemVariables: [],
  userVariables: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,

  RECEIVE_SYSTEM_VARIABLES(state, systemVariables) {
    state.systemVariables = systemVariables
  },

  RECEIVE_USER_VARIABLES(state, userVariables) {
    state.userVariables = userVariables
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        ...context.state.queryBuilder
      },
      attributes
    )

    context.commit('SET_QUERY_BUILDER', attributes)

    return PayUserVariable.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return PayUserVariable.store(data)
  },

  update(context, { id, ...data }) {
    return PayUserVariable.update(id, data)
  },

  destroy(context, id) {
    return PayUserVariable.destroy(id).then(response => {
      let resource = context.state.resources.find(r => r.deduction_id == id)

      if (resource) {
        context.state.resources.splice(context.state.resources.indexOf(resource), 1)
      }

      return response
    })
  },

  fetchSystemVariables(context, attributes = {}) {
    let params = {
      page: -1,
      ...attributes
    }

    return PaySystemVariable.get({ params }).then(response => {
      context.commit('RECEIVE_SYSTEM_VARIABLES', response.data)
      return Promise.resolve(response)
    })
  },

  fetchUserVariables(context, attributes = {}) {
    let params = {
      page: -1,
      ...attributes
    }

    return PayUserVariable.get({ params }).then(response => {
      context.commit('RECEIVE_USER_VARIABLES', response.data)
      return Promise.resolve(response)
    })
  }
}
